import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface TenderFinalizationProgress {
  stageInProgress: string
  percentComplete: number | null
  timestamp: string
}

interface TenderFinalizationState {
  currentStageInProgress: string
  progressPercentage: number | null
  progressMessage: string
  isFinalizationInProgress: boolean
  error: string | null
}

const initialState: TenderFinalizationState = {
  currentStageInProgress: '',
  progressPercentage: 0,
  progressMessage: '',
  isFinalizationInProgress: false,
  error: null
}

const tenderFinalizationSlice = createSlice({
  name: 'tenderFinalization',
  initialState,
  reducers: {
    setFinalizationProgress: (state, action: PayloadAction<TenderFinalizationProgress>) => {
      state.currentStageInProgress = action.payload.stageInProgress
      state.progressPercentage = action.payload.percentComplete
      state.progressMessage = `${action.payload.stageInProgress} - ${action.payload.percentComplete}`
      state.isFinalizationInProgress = true
      state.error = null
    },
    finalizationError: (state, action: PayloadAction<string>) => {
      state.isFinalizationInProgress = false
      state.error = action.payload
      state.progressMessage = `Error: ${action.payload}`
    },
    resetFinalizationProgress: _ => initialState
  }
})

export const {
  setFinalizationProgress,
  //   startFinalization,
  //   finalizationComplete,
  finalizationError,
  resetFinalizationProgress
} = tenderFinalizationSlice.actions

export default tenderFinalizationSlice.reducer
